import React from "react";
import { Link } from "react-router-dom";
import { formatINR } from "./ChefCard";

export default function MenuCard({ menu }) {
  return (
    <Link
      to={`/menus/${menu.id}`}
      data-testid={`menu-card-${menu.id}`}
      className="card-lux group flex flex-col md:flex-row"
    >
      <div className="md:w-2/5 aspect-[4/3] md:aspect-auto overflow-hidden bg-neutral-900">
        <img
          src={menu.image_url}
          alt={menu.title}
          className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
        />
      </div>
      <div className="md:w-3/5 p-7 flex flex-col justify-between gap-5">
        <div>
          <div className="flex items-center gap-3 mb-3">
            <span className="chip text-[#F5B041]">{menu.category}</span>
            {menu.featured && <span className="chip text-[#C04000] border-[#C04000]/40">Signature</span>}
          </div>
          <div className="font-serif-display text-3xl leading-tight">{menu.title}</div>
          <div className="font-script text-lg text-neutral-400 mt-1">{menu.tagline}</div>
          <div className="dotted-sep my-4" />
          <p className="text-neutral-400 text-sm leading-relaxed line-clamp-3">{menu.description}</p>
        </div>
        <div className="flex items-end justify-between">
          <div>
            <div className="small-caps text-[10px] text-neutral-500">Per head</div>
            <div className="font-serif-menu text-2xl">₹{formatINR(menu.price_per_head)}</div>
          </div>
          <div>
            <div className="small-caps text-[10px] text-neutral-500">Min guests</div>
            <div className="font-serif-menu text-2xl text-right">{menu.min_guests}</div>
          </div>
        </div>
      </div>
    </Link>
  );
}
